/**
 * 新增银行卡
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 */
import React from 'react';
import { message, Spin,Button } from "antd";
import Lang from "@/components/Lang/Lang";
import {isEmptyObject} from '@utils/utils';
import FormFormat from '@/components/FormFormat/FormFormat';
import EssaModal from "@/components/EssaModal/EssaModal";
import HttpServerAction from '@/api/httpServer.action';
import "./addBank.less"

class AddBankModal extends React.Component{
    static defaultProps = {
        buyerId:"",//采购商ID
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showModal: false,
            cusObj:{}
        }
    }
    changeType(type=""){
        this.setState({
            type:type
        })
    }
    /**
     * 弹窗
     * */
    openModal(flag,){
        if(flag){
            const {cusObj} = this.state;
            if(isEmptyObject(cusObj)){
                const {buyerId} = this.props;
                this.loading(true);
                HttpServerAction.postHttpAction('/service/mg/contract/list',{
                    buyerId: buyerId,
                    pagingQuery: {
                        pageIndex: 1,
                        pageSize: 1,
                    },
                },).then((resp)=>this.handleGetRes(resp.data)).catch(err=>this.handleGetRes(err));
            }
            // else {
            //
            // }
            this.setState({
                showModal: flag
            })
        }else {//取消时清空数据
            this.changeType("");
            this.setState({
                showModal: flag
            })
        }

    }
    handleGetRes(res) {
        const {success, valid, models = []} = res;
        this.loading(false);
        if (success && valid) {
            if(models&&models.length>0){
                this.setState({
                    cusObj:models[0],
                    // showModal:true
                })
            }
            // else{
            //     // 请先新增合同
            //     message.open({
            //         type: 'warning',
            //         content: Lang({id: 'QingXianXinZengHeTong', default: '请先新增合同'})//''
            //     });
            // }
        }
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }
   async handleOk(){
           const res = await this.onRefFormFormat2.handleOK();
           console.log("res",res);
           const {cusObj} = this.state;
           if(cusObj&&cusObj.id) {
               if (res && res.success) {
                   const data = res.data;
                   const {buyerId, row} = this.props;
                   this.loading(true);
                   let postData = {
                       ...data,
                       buyerId: buyerId
                   }
                   let sUrl = "/service/mg/buyer/bank/add";
                   if (row && row.id) {
                       sUrl = "/service/mg/buyer/bank/update";
                       postData["id"] = row.id;
                   }
                   HttpServerAction.postHttpAction(sUrl, postData).then((resp) => this.handleRes(resp.data)).catch(err => this.handleRes(err));
               }
           }else {
               // 请先新增合同
               message.open({
                   type: 'warning',
                   content: Lang({id: 'QingXianXinZengHeTong', default: '请先新增合同'})//''
               });
           }
    }
    handleRes(response={}){
        this.loading(false);
        if (response.success && response.valid) {
            message.open({
                type: 'success',
                content: Lang({id: 'CaoZuoChengGong', default: '操作成功'}),
            });
            //重置内容
            this.openModal(false);
            // 刷新 页面数据
            setTimeout(()=>{
               if(this.props.refreshPage)this.props.refreshPage();
            },200)
        }else if (response.message){
            message.open({
                type: 'info',
                content: response.message,
            });
        }else{
            message.open({
                type: 'warning',
                content: Lang({id: 'CaoZuoShiBai',default:'操作失败'}),
            });
        }
    }
    onRefForm2= (ref) =>  this.onRefFormFormat2 = ref;
    render(){
        const {row,children,className} = this.props;
        const {loading, showModal, cusObj={}} = this.state;
        return (<Spin spinning={loading}>
                <span className={className} onClick={()=>this.openModal(true,row)}>
                    {children||<span className={"font-main2 ml_4 cursor-p"}>{Lang({id: "XinZeng",default: "新增"})}</span>}
                </span>
                {showModal&&<EssaModal// title={Lang({id: "XinZengShouKuanYinXingKa",default: "新增收款银行卡"})}
                                        open={showModal}
                                        width={600}
                                        footer={null}
                                        // onOk={()=>this.handleOk()}
                                        // okText={Lang({id: "TiJiao",default: "提交"})}
                                        onCancel={()=>this.openModal(false)}>
                    <Spin spinning={loading}>
                        <div className={"AddBankWrap"}>
                            <div className={"font_20 fw_500 black66 mb_20"}>{Lang({id: "XinZengShouKuanYinXingKa",default: "新增收款银行卡"})}</div>
                            <FormFormat onRef={this.onRefForm2}
                                        initialValues={row}
                                        options={[{
                                            type:'OnlyRender', //
                                            cnTitle:'收款公司',
                                            cnTitleId:'ShouKuanGongSi',
                                            onlyRender: cusObj.companyName?<div>
                                                <div className={"black66"}>{cusObj.companyName||"-"}</div>
                                                <div className={"color-err font_12"}>{Lang({id: 'ZhiNengHuiKuanDaoQianDing', default: '只能汇款到签订合同的公司主体'})}</div>
                                            </div>:<div className={"color-err font_12"}>
                                                {Lang({id: 'QingLianXiKeHuChaKanNinHe', default: '请联系客户查看您和平台签订的合同，只能使用合同的公司主体进行收款'})}
                                            </div>,
                                            showTitle: true,
                                        },{
                                            name:'bankName',
                                            cnTitle:'选择收款银行',
                                            cnTitleId:'XuanZeShouKuanYinXingKa',
                                            type:"Enum",
                                            enumClass:"buy_buyer_bank_config",
                                            required:true
                                        }, {
                                            name:'bankNo',
                                            cnTitle:'填写银行卡号',
                                            cnTitleId:'TianXieYinXingKaHao',
                                            required:true,
                                            maxLength:256,
                                            type:"BankNo",
                                            // formatSpace:true,
                                            // isBankCard:true,
                                            },
                                        ]}
                                        size={"middle"}
                                        formLayout = "vertical" />
                            <div className={"text-right mt_20"}>
                                <Button onClick={()=>this.openModal(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                               <Button type={'primary'} className={"ml_12"}
                                       disabled={!cusObj.companyName}
                                       onClick={()=>this.handleOk()}>{Lang({id: "TiJiao",default: "提交"})}</Button>
                            </div>
                        </div>
                    </Spin>
                </EssaModal>}
            </Spin>
        )
    }
}

export default AddBankModal;
